/** ArollWalletChip.tsx — header usage chip. */
export const wallet = {
  /** Suffix on the hover title; leading separator included. {date} is a
   *  short localised date ("2 Aug"). */
  'wallet.resets': ' · resets {date}',
  'wallet.trial': 'Trial',
  /** Hover title. */
  'wallet.title': 'AI drafts {draftsUsed}/{draftsAllowance} · footage {minutesUsed}/{minutesAllowance} min{reset}',
  /** Visible chip text. {drafts} like "3/50", {hours} like "1.2/6.0". */
  'wallet.meters': '{drafts} drafts · {hours} hrs',
  /** Appended after wallet.meters when the plan includes Playback
   *  review minutes ({review} = "36/200"). Leading separator included. */
  'wallet.review': ' · {review} rev min',
} as const;
